import React from 'react'
import { Box, Flex, Text } from '../../../core-components'

export const overflowPillMeasurerDataPill = 'overflow-pill-measurer'
interface Props {
  invisibleValuesCount: number
  totalValuesCount: number
}

export const OverflowPillWithMeasurer = ({ invisibleValuesCount, totalValuesCount }: Props) => {
  return (
    <>
      {invisibleValuesCount > 0 && <OverflowPill>{invisibleValuesCount}</OverflowPill>}
      <Box
        data-pill={overflowPillMeasurerDataPill}
        style={{ position: 'absolute', top: 0, left: 0, visibility: 'hidden' }}
      >
        <OverflowPill>
          {
            '4'.repeat(
              String(totalValuesCount).length
            ) /* 4 is the widest letter in our font because we want to have more space than necessary rather than too little */
          }
        </OverflowPill>
      </Box>
    </>
  )
}

const OverflowPill = ({ children }: { children: React.ReactNode }) => {
  return (
    <Flex
      px={2}
      h='28px'
      alignItems='center'
      borderRadius={8}
      flexShrink={0}
      boxShadow='border/section'
      bg='bg/button-minor-default'
    >
      <Text textStyle='form-value' color='fg/major'>
        +{children}
      </Text>
    </Flex>
  )
}
